import type { ReactNode } from "react";
import { Button } from "./button";
import type { ButtonProps } from "./button";
import { classNames } from "./internal/class-names";
import { Tooltip } from "./tooltip";

export interface IconButtonProps extends Omit<ButtonProps, "children"> {
  /** Accessible name. Required — an icon alone is never a label. */
  readonly label: string;
  /** The glyph. Hidden from assistive technology; `label` carries the meaning. */
  readonly icon: ReactNode;
  /** Localized tooltip. Defaults to `label`. */
  readonly tooltip?: string | undefined;
}

/** Compact action whose visible content is an icon and whose name is `label`. */
export function IconButton({ className, icon, label, title, tooltip = title ?? label, ...rest }: IconButtonProps): ReactNode {
  return (
    <Tooltip label={tooltip}>
      <Button {...rest} aria-label={label} className={classNames("thw-icon-button", className)}>
        <span aria-hidden="true" className="thw-icon-button__glyph">
          {icon}
        </span>
      </Button>
    </Tooltip>
  );
}
